export default function () {
    const entityClass = useEntityClass();

    async function get(filter) {
        let classes = null,
            error = null;
        try {
            const {data} = await useApi('classes').get('classes', filter);
            classes = data.classes.map((item) => {
                return entityClass.build(item);
            });
        } catch (e) {
            error = useApiError(e);
        }
        return {classes, error};
    }

    return {get};
}
